import { DistributionContent } from "@/types/generated/ExperienceRawServiceApi";
import { useCalendarTokenPermissions } from "@/features/token-permissions/composables/useCalendarTokenPermissions";

export function shouldLoadOfferExperience(productType?: DistributionContent["experience_source"]) {
  const { canViewCalendar } = useCalendarTokenPermissions();
  if (!canViewCalendar()) {
    return false;
  }

  if (productType) {
    return productType === "NOVA" || productType === "NOVANET";
  } else return true;
}
